var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:_vm.$options.methods.getClass(_vm.props),attrs:{"viewBox":"0 0 24 24","role":"img"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":_vm.$options.methods.getPath(_vm.props)}})])}
var staticRenderFns = []

export { render, staticRenderFns }